import { createTheme } from '@mui/material/styles';

/**
 * TalentSense brand colours (from the 2026 brand board).
 * Blue leads as the action/primary colour; turquoise is the secondary accent.
 */
export const BRAND_BLUE = '#1F3A8A';
export const BRAND_TURQUOISE = '#0CCBFE';

/** Single source of truth for the brand primary colour. */
export const PRIMARY_BLUE = BRAND_BLUE;

/** Single source of truth for the text colour — every font renders in this violet. */
export const TEXT_COLOR = '#2F2776';

const theme = createTheme({
    palette: {
        primary: { main: BRAND_BLUE },
        secondary: { main: BRAND_TURQUOISE },
        background: { default: '#F6F7FB', paper: '#FFFFFF' },
        text: { primary: TEXT_COLOR, secondary: TEXT_COLOR },
    },
    shape: { borderRadius: 10 },
    typography: {
        fontFamily: ['"Inter"', 'sans-serif'].join(','),
        allVariants: { color: TEXT_COLOR },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiCssBaseline: {
            // Default body text colour, so anything that simply inherits renders in the brand violet.
            styleOverrides: { body: { color: TEXT_COLOR } },
        },
        MuiButton: {
            styleOverrides: { root: { borderRadius: 10, paddingBlock: 10 } },
        },
        MuiOutlinedInput: {
            styleOverrides: { root: { borderRadius: 10 } },
        },
    },
});

export default theme;
